import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

// Context providers
import AppProvider from "./Context/AppContext.js";
import { AuthProvider } from "./Context/authContext.jsx";

// Translation
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n.js";

// Toast notifications
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles and libraries
import "bootstrap/dist/css/bootstrap.min.css"; // only once
import "react-loading-skeleton/dist/skeleton.css";

const url = new URL(window.location.href);
const subdomain = url.hostname.split(".")[0];

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <AuthProvider>
      <AppProvider>
        <App subdomain={subdomain} />
      </AppProvider>
    </AuthProvider>
    <ToastContainer />
  </I18nextProvider>
);
